import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthService } from 'src/app/services/auth.service';
import { LoaderService } from 'src/app/services/loader.service';

@Component({
    selector: 'app-system-status-overview',
    templateUrl: './system-status-overview.component.html',
    styleUrls: ['./system-status-overview.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class SystemStatusOverviewComponent implements OnInit {
  page: string = 'opkraevninger';

  constructor(activatedRoute: ActivatedRoute, private auth: AuthService, private router: Router, private loader: LoaderService) {
    if (!this.auth.isAdministrator) {
      this.router.navigate(['forbidden']);
    }

    activatedRoute.fragment.subscribe((p) => {
      if (p) this.page = p;
    });
  }

  ngOnInit(): void {

  }
}
